import { create } from 'zustand';

interface BackLinkState {
  onBack: (() => void) | null;
  label: string | null;
  setBackLink: (onBack: () => void, label: string) => void;
  clearBackLink: () => void;
}

export const useBackLinkStore = create<BackLinkState>((set) => ({
  onBack: null,
  label: null,
  setBackLink: (onBack, label) => set({ onBack, label }),
  clearBackLink: () => set({ onBack: null, label: null }),
}));

export default useBackLinkStore;
